var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":_vm.onInit}})}
var staticRenderFns = []

export { render, staticRenderFns }